import { promoActive, promoData } from "./promoConfig";

export function getDisplayedPrice(tier, userInfo) {
  if (
    !userInfo?.coupon_details ||
    !promoData.plansOnPromo.includes(tier.title)
  ) {
    return {
      isPromo: false,
      price: tier.price,
    };
  }
  const oldPrice = tier.price;
  const discountedPrice = Math.round(
    oldPrice * (1 - userInfo?.coupon_details?.percent_off / 100)
  );

  return {
    isPromo: true,
    oldPrice,
    price: discountedPrice,
    percent: userInfo?.coupon_details?.percent_off
      ? userInfo?.coupon_details?.percent_off
      : 0,
  };
}
